module.exports = __webpack_public_path__ + "img/ips.cc79067b.png";